module.exports = __webpack_public_path__ + "img/FAQ02.995ff917.png";